const INCLUDES = [
  { icon: 'ri-stack-line', label: 'Металл и комплектующие', desc: 'Профильная труба, пруток, полоса. Усиленные анкеры и крепёж с защитой от среза' },
  { icon: 'ri-layout-5-line', label: 'Изготовление', desc: 'Резка, сварка, зачистка швов, сборка рамы и заполнения под размеры проёма' },
  { icon: 'ri-paint-brush-line', label: 'Покраска', desc: 'Двухэтапная обработка: цинковый грунт и полимерно-порошковое покрытие в цвет RAL' },
  { icon: 'ri-truck-line', label: 'Доставка', desc: 'Бережная транспортировка готовых решёток до вашего объекта' },
  { icon: 'ri-tools-fill', label: 'Монтаж', desc: 'Установка на анкеры в стену, контроль геометрии, финишная проверка и уборка' },
];

const DURABILITY = [
  {
    icon: 'ri-hard-drive-2-line',
    title: 'Прочный каркас',
    desc: 'Профильная труба и пруток с&nbsp;запасом прочности. Решётка выдерживает значительные механические нагрузки без&nbsp;деформации.',
  },
  {
    icon: 'ri-calculator-line',
    title: 'Расчёт нагрузок',
    desc: 'Проектируем с&nbsp;учётом ветровой нагрузки для&nbsp;вашего региона и&nbsp;этажности. Распашные створки проверяем на&nbsp;провисание.',
  },
  {
    icon: 'ri-shield-flash-line',
    title: 'Антикоррозийная защита',
    desc: 'Двухэтапная обработка: цинковый грунт и&nbsp;полимерно-порошковое покрытие. Защита от&nbsp;дождя, снега и&nbsp;перепадов&nbsp;температур.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Качественная покраска',
    desc: 'Порошковая покраска по&nbsp;каталогу RAL. Подберём цвет под&nbsp;фасад или&nbsp;раму окна. Покрытие не&nbsp;выгорает и&nbsp;не&nbsp;шелушится.',
  },
];

export default function WhySection() {
  return (
    <>
      {/* What's included */}
      <section className="py-16 md:py-20 bg-background-50">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Что входит в стоимость
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Прозрачная комплектация — вы точно знаете, из&nbsp;чего складывается&nbsp;цена
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {INCLUDES.map((item, idx) => (
              <div
                key={item.label}
                className="text-center group animate-fade-in-up"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-400">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1.5">{item.label}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Durability */}
      <section className="py-16 md:py-20 bg-background-100">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Почему конструкция прослужит долго
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Четыре причины, по которым решётки остаются надёжными десятилетиями без&nbsp;ремонта
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {DURABILITY.map((item, idx) => (
              <div
                key={item.title}
                className="flex items-start gap-5 bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-7 transition-all duration-400 hover:border-primary-200/50 animate-fade-in-up"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className="shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}